import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M263-185q-20 0-35-15-15-14-15-35t15-35q15-15 35-15h87l135-397H380q-21 0-35-14-15-15-15-36 0-20 15-35 14-14 35-14h300q20 0 35 15 14 14 14 35 0 20-14 35-15 14-35 14h-87L458-285h105q21 0 35 15 15 15 15 35 0 21-15 36t-35 14H263Z"/>',
  f: '<path d="M263-185q-20 0-35-15-15-14-15-35t15-35q15-15 35-15h87l135-397H380q-21 0-35-14-15-15-15-36 0-20 15-35 14-14 35-14h300q20 0 35 15 14 14 14 35 0 20-14 35-15 14-35 14h-87L458-285h105q21 0 35 15 15 15 15 35 0 21-15 36t-35 14H263Z"/>',
};

export default data;
